import styled from 'styled-components'

export const Container = styled.div`
    flex-wrap: wrap;
    .text-bar{
        margin: 10px 0px;
        margin-right: 10px;
    }

    .floating-button{
        position: fixed;
        z-index: 2000;
        right: 1%;
    }

    .submit-button{
        width: 100px;
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .upload-input{
        display: none;
    }

    .form{
        display: flex;
        flex-direction: column;
        width: 50%;
    }

    .product-container{
        border: 1px solid #e2e2e2;
    }

    .image-preview{
        background-size: contain;    
    }

    .no-image-container{
        display: flex;
        width: 500px;
        height: 500px;
        justify-content: center;
        align-items: center;
        border: 1px solid #e2e2e2;
    }
`

export const ToRow = styled.div`
    flex-direction: row;
    display: flex;
    margin-top: 50px;
    align-items: center;
`

export const ToColumn = styled.div`
    flex-direction: column;
    display: flex;
    margin-top: 50px;
`

export const CheckBox = styled.input`

`
